// extracted by mini-css-extract-plugin
export default {"gridTemplateColumns":"_ed902843"};